import axios from "@shared/axios";
import SurveyUserHistoryInterface from "@shared-interfaces/box/survey.user.history.interface";
import Survey from "@shared-models/box/survey.model";
import SurveyUserAnswerInterface from "@shared-interfaces/box/survey.user.answer.interface";

async function getSurvey(surveyId: string): Promise<Survey>
{
	const response = await axios.get(
		`/box/surveys/${ surveyId }`,
	);

	return response?.data as Survey ?? null;
}

async function getSurveysHistory(lastUlid: string | null | undefined = null): Promise<SurveyUserHistoryInterface>
{
	const params: Record<string, string | string[]> = {};

	if (lastUlid)
	{
		params.lastUlid = lastUlid;
	}

	const response = await axios.get(
		"/box/surveys",
		{ params }
	);

	return response?.data as SurveyUserHistoryInterface ?? { data: {}, total: 0 };
}

async function saveDraft(survey: Survey, answers: SurveyUserAnswerInterface[])
{
	const response = await axios.put(
		`/box/surveys/${ survey.id }/draft`,
		{
			answers
		}
	);

	return response?.data ?? null;
}

async function confirmAnswers(survey: Survey, answers: SurveyUserAnswerInterface[])
{
	const response = await axios.put(
		`/box/surveys/${ survey.id }/confirm-answers`,
		{
			answers
		}
	);

	return response?.data ?? null;
}

async function getUnreadSurveysUserCount(): Promise<number>
{
	const response = await axios.get(
		"/box/surveys/unread-count"
	);

	return response?.data ?? null;
}

export {
	getSurvey,
	getSurveysHistory,
	saveDraft,
	confirmAnswers,
	getUnreadSurveysUserCount
};
